import {v4 as uuidv4} from 'uuid';
import {ConfiguratorV2Options} from './storeConfigurator';

export const STORE_CONFIGURATOR_KEY = 'store-configurator-v2-data';
const MIXPANEL_ID_KEY = 'mixpanel_id';
const AUTH_UID_KEY = 'auth_uid';
const LAST_UID_CHECK = 'last_uid_check';

// Try catch is needed for server-side rendering, as localstorage doesn't exist.

export const getLocalStorageConfiguratorV2Data = () => {
  try {
    const res = localStorage.getItem(STORE_CONFIGURATOR_KEY);

    if (!res) return undefined;

    return JSON.parse(res) as ConfiguratorV2Options;
  } catch (err) {
    return undefined;
  }
};

export const getLocalStorageMixpanelId = () => {
  try {
    const res = localStorage.getItem(MIXPANEL_ID_KEY);
    if (res) return res;

    const newId = uuidv4();
    localStorage.setItem(MIXPANEL_ID_KEY, `$device:${newId}`);
    return newId;
  } catch {
    return '';
  }
};

export const getLocalStorageUid = () => {
  try {
    return localStorage.getItem(AUTH_UID_KEY);
  } catch {
    return null;
  }
};

export const setLocalStorageUid = (id: string) => {
  try {
    localStorage.setItem(AUTH_UID_KEY, id);
  } catch {
    // NOOP
  }
};

export const getLocalStorageLastUidCheck = () => {
  try {
    return Number(localStorage.getItem(LAST_UID_CHECK) || 0);
  } catch {
    return 0;
  }
};

export const setLocalStorageLastUidCheck = (timestamp: number) => {
  try {
    localStorage.setItem(LAST_UID_CHECK, String(timestamp));
  } catch {
    // NOOP
  }
};
